import React from 'react';
import { withRouter } from 'react-router';
import ImageSlider from './ImageSlider';
import '../statics/stylesheet.css';

const getPrices = (size, children) => {
  const tempArray = [];
  if (children && size) {
    for (let i = 0; i < children.length; i++) {
      for (let j = 0; j < size.length; j++) {
        if (size[j] === children[i].wheel_size) {
          tempArray.push(children[i].price);
        }
      }
    }
  }
  return tempArray;
};

class ProductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  getTiresBySize(size) {
    const sizes = size.split('-');
    this.setState({ loading: true });

    const urlStaggered = window.baseUrl + '/apii/tires.php/search/tires/staggered/tread-width-back/' + sizes[3] + '/wheel-profile-back/' + sizes[4] + '/wheel-size-back/' + sizes[5] +
            '/tread-width-front/' + sizes[0] + '/wheel-profile-front/' + sizes[1] + '/wheel-size-front/' + sizes[2];
    const url = window.baseUrl + '/apii/tires.php/search/tires/size/wheel-profile/' + sizes[1] + '/wheel-size/' + sizes[2] + '/tread-width/' + sizes[0];

    // Get selected seasons from localStorage
    const jafar = new URL(window.location.href);
    const jafarseason = jafar.searchParams.get('season');

    if (jafarseason === 'winter') {
      localStorage.setItem('selected_tire_seasons', '["Winter"]');
    } else if (jafarseason === 'summer') {
      localStorage.setItem('selected_tire_seasons', '["Summer"]');
    } else if (jafarseason === 'all weather') {
      localStorage.setItem('selected_tire_seasons', '["All Weather"]');
    } else if (jafarseason === 'all season') {
      localStorage.setItem('selected_tire_seasons', '["All Season"]');
    }

    const selectedSeasons = JSON.parse(localStorage.getItem('selected_tire_seasons') || '[]');

    const shouldFilterSeasons = selectedSeasons.length > 0;

    const fetchUrl = sizes.length > 3 ? urlStaggered : url;
    
    fetch(fetchUrl)
      .then(response => response.json())
      .then(json => {
        let filteredProducts = json;
        
        // Only filter if seasons are selected
        if (shouldFilterSeasons) {
          filteredProducts = json.filter(item => 
            selectedSeasons.includes(item.performance_category)
          );
        }
        
        this.setState({ loading: false, products: filteredProducts });
      });
  }

  getWheelsBySize(size) {
    const sizesTires = size.split('--');
    window.localStorage.setItem('SIZE', sizesTires[0]);
    this.setState({ loading: true });

    const url = window.baseUrl + '/apii/wheels.php/search/wheels/size/offset/' + sizesTires[2] + '/bolt-pattern/' + sizesTires[1] + '/width/' + sizesTires[3] + '/size/' + sizesTires[0] + '/centerbore/' + sizesTires[4];
    const urlStaggered = window.baseUrl + '/apii/wheels.php/search/wheels/sizestaggered/width-front/' + sizesTires[3] + '/width-back/' + sizesTires[4] +
            '/size/' + sizesTires[0] + '/bolt-pattern/' + sizesTires[1] + '/offset/' + sizesTires[2] + '/centerbore/' + sizesTires[5];
    if (sizesTires.length > 5) {
      window.localStorage.setItem('search_by', 'size Staggered');
      fetch(urlStaggered)
                .then(response => {
                  return response.json();
                }).then(json => {
                  this.setState({ loading: false, products: json });
                });
    } else {
      window.localStorage.setItem('search_by', 'size non-Staggered');
      fetch(url)
                .then(response => {
                  return response.json();
                }).then(json => {
                  this.setState({ loading: false, products: json });
                });
    }
  }

  async getProductByVehicle(category, options) {
    const vehicle = options.split('!');
    this.setState({ loading: true });

    window.localStorage.setItem('SIZE', this.props.params.size);

    if ( this.props.params.category === 'Winter Packages') {
      window.localStorage.setItem('winter wheels', 'false');
    }

    const modifiedModel = vehicle[2].split('/').join('|');
    let url = '';
    let width2 = '';
    let offset2 = '';
    let offset3 = '';
    let size4 = '';

    if (window.sessionStorage.getItem('Staggered')) {
      size4 = window.localStorage.getItem('vsize_search');
      url = window.baseUrl + '/apii/wheels.php/search/wheels/staggered/year/' + vehicle[0] + '/make/' + vehicle[1] + '/model/' + modifiedModel + '/size/' + size4;

    } else if (window.localStorage.getItem('customsizing') && window.localStorage.getItem('customsizing') !== 'all' ) {
      width2 = window.localStorage.getItem('width2');
      offset2 = window.localStorage.getItem('offset2');
      offset3 = window.localStorage.getItem('offset3');
      url = window.baseUrl + '/apii/wheels.php/search/wheels/vehicle/year/' + vehicle[0] + '/make/' + vehicle[1] + '/model/' + modifiedModel + '/width2/' + width2 + '/offset2/' + offset2 + '/offset3/' + offset3;
    } else {
      url = window.baseUrl + '/apii/wheels.php/search/wheels/vehicle/year/' + vehicle[0] + '/make/' + vehicle[1] + '/model/' + modifiedModel;
    }

    try {
      const response = await fetch(url);

      const result = await response.json();
      this.setState({ loading: false, products: result });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  }
    /**
     * @returns
     *
     * @memberOf ProductList
     */
  getGroupAttribute() {
    const { category, search_by } = this.props.params;

    if (search_by === 'Brand') {

      if (category === 'Wheels') {
        return 'model';
      } else if (category === 'Tires') {
        return 'performance_category';
      }
      return 'model';
    }

    if (category === 'Wheels' || category === 'Winter Packages') {
      return 'wheel_manufacturer';
    } else if (category === 'Tires') {
      return 'tire_manufacturer';
    }
    return 'accessories_manufacturer';
  }

  sizeSort(products) {
    const { size, search_by } = this.props.params;
    const sizes = size.split('-');
    const filteredProducts = [];
    const fProductstest3 = [];
    const fProductstest2 = [];
    const fProductstest = [];
    const houmanCarModel2 = window.localStorage.getItem('carModel');
    const houmanCarYear2 = window.localStorage.getItem('carYear');
    const wheelsstatus = window.localStorage.getItem('wheels_status');
    const Vehiclemode = window.localStorage.getItem('customsizing') || '';
    const Vehiclesearch = window.localStorage.getItem('search_by') || '';

    if (products) {
      for (let i = 0; i < products.length; i++) {
        if (products[i].children) {
          for (let j = 0; j < products[i].children.length; j++) {
            if (sizes.indexOf(products[i].children[j].wheel_size) > -1 && !(filteredProducts.indexOf(products[i]) > -1) ) {
              filteredProducts.push(products[i]);
            }
          }
        }
      }
    }

    if (Vehiclesearch && Vehiclesearch === 'size Staggered' ) {
      const frontOffmin = window.localStorage.getItem('front offset min') || 0;
      const frontOffmax = window.localStorage.getItem('front offset max') || 70;
      const rearOffmin = window.localStorage.getItem('rear offset min') || 0;
      const rearOffmax = window.localStorage.getItem('rear offset max') || 70;

      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && !(fProductstest2.indexOf(fProductstest[k]) >= 0)) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      for (let h = 0; h < fProductstest2.length; h++) {
        for (let a = 0; a < fProductstest2[h].children.length; a++) {
          if ( Number(fProductstest2[h].children[0].wheel_width) > Number(fProductstest2[h].children[1].wheel_width) && !(fProductstest3.indexOf(fProductstest2[h]) >= 0)) {
            if (Number(fProductstest2[h].children[0].offsetmm) >= rearOffmin && Number(fProductstest2[h].children[0].offsetmm) <= rearOffmax && Number(fProductstest2[h].children[1].offsetmm) <= frontOffmax && Number(fProductstest2[h].children[1].offsetmm) >= frontOffmin) {
              fProductstest3.push(fProductstest2[h]);
            }
          } else if ( Number(fProductstest2[h].children[1].offsetmm) >= rearOffmin && Number(fProductstest2[h].children[1].offsetmm) <= rearOffmax && Number(fProductstest2[h].children[0].offsetmm) <= frontOffmax && Number(fProductstest2[h].children[0].offsetmm) >= frontOffmin && !(fProductstest3.indexOf(fProductstest2[h]) >= 0)) {
            fProductstest3.push(fProductstest2[h]);
          }
        }
      }
      return fProductstest3;
    }

    //TESLA MODEL S:
    if (Vehiclesearch && Vehiclemode === 'TESLA S' && houmanCarModel2.indexOf('MODEL S') > -1) {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( (filteredProducts[i].children[j].wheel_width === '8.5' || filteredProducts[i].children[j].wheel_width === '9') && !(fProductstest.indexOf(products[i]) >= 0)) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let l = 0; l < fProductstest[k].children.length; l++) {
          if (fProductstest[k].children[l].wheel_width === '8' ) {
            const fpindex = fProductstest.indexOf(fProductstest[k]);
            fProductstest.splice(fpindex, 1);
          }
        }
      }
      return fProductstest;
    }
    //TESLA MODEL X:
    if (Vehiclesearch && Vehiclesearch === 'TESLA X' && houmanCarModel2.indexOf('MODEL X') > -1) {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ((filteredProducts[i].children[j].wheel_width === '8.5' || filteredProducts[i].children[j].wheel_width === '9') && !(fProductstest.indexOf(products[i]) >= 0)) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let i = 0; i < fProductstest.length; i++) {
        for (let j = 0; j < fProductstest[i].children.length; j++) {
          if (fProductstest[i].children[j].wheel_width === '11' && fProductstest[i].children[j].wheel_size === '20' ) {
            const fpindex = fProductstest.indexOf(fProductstest[i]);
            fProductstest.splice(fpindex, 1);
          }
        }
      }
      return fProductstest;
    }
    //TESLA MODEL 3:
    if (Vehiclesearch && Vehiclemode === 'TESLA3' && houmanCarModel2 === 'MODEL 3') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && (filteredProducts[i].children[j].wheel_width === '8' || filteredProducts[i].children[j].wheel_width === '8.5' || filteredProducts[i].children[j].wheel_width === '9') && !(fProductstest.indexOf(filteredProducts[i]) >= 0)) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }

      for (let k = 0; k < fProductstest.length; k++) {
        if ( fProductstest[k].children.length >= 2 && fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width ) {
          fProductstest2.push(fProductstest[k]);
        }
      }
      if (wheelsstatus !== 'Non-Staggered') {
        return fProductstest2;
      }
      return fProductstest;
    }

    if (Vehiclesearch && Vehiclesearch === 'S CLASS old' && houmanCarModel2.indexOf('S CLASS') > -1 && houmanCarYear2 < 2014 && houmanCarYear2 > 2006) {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && (filteredProducts[i].children[j].wheel_width === '8.5' || filteredProducts[i].children[j].wheel_width === '8' || filteredProducts[i].children[j].wheel_width === '9') && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }

      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children.length >= 2 && fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && fProductstest[k].children[1].wheel_width !== '9' && !(fProductstest2.indexOf(fProductstest[k]) >= 0) ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }

    if (Vehiclesearch && Vehiclesearch === 'BMW X7' && wheelsstatus !== 'Non-Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && (filteredProducts[i].children[j].wheel_width === '9' || filteredProducts[i].children[j].wheel_width === '9.5' || filteredProducts[i].children[j].wheel_width === '10' || filteredProducts[i].children[j].wheel_width === '10.5' || filteredProducts[i].children[j].wheel_width === '11') && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( sizes.indexOf(fProductstest[k].children[m].wheel_size) >= 0 && (fProductstest[k].children[m].wheel_width === '10.5' || fProductstest[k].children[m].wheel_width === '11') ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }

    if (Vehiclesearch && Vehiclesearch === 'S CLASS new' && houmanCarModel2.indexOf('S CLASS') > -1 && houmanCarYear2 > 2013 && houmanCarYear2 < 2021) {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && (filteredProducts[i].children[j].wheel_width === '8.5' || filteredProducts[i].children[j].wheel_width === '9' || filteredProducts[i].children[j].wheel_width === '9.5')) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children.length >= 2 && fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && fProductstest[k].children[0].wheel_width !== '8' && !(fProductstest2.indexOf(fProductstest[k]) >= 0) ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }

    if (Vehiclesearch && Vehiclesearch === 'TESLA Y' && houmanCarModel2 === 'MODEL Y' && wheelsstatus !== 'Non-Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && (filteredProducts[i].children[j].wheel_width === '8.5' || filteredProducts[i].children[j].wheel_width === '9' || filteredProducts[i].children[j].wheel_width === '9.5' || filteredProducts[i].children[j].wheel_width === '10.5') && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( sizes.indexOf(fProductstest[k].children[m].wheel_size) >= 0 && fProductstest[k].children[m].wheel_width === '10.5' ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }

    if (Vehiclesearch && houmanCarModel2 === 'MODEL Y' && wheelsstatus === 'Non-Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && (filteredProducts[i].children[j].wheel_width === '8.5' || filteredProducts[i].children[j].wheel_width === '9' || filteredProducts[i].children[j].wheel_width === '9.5') && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      return fProductstest;
    }

    if (Vehiclesearch && Vehiclesearch === 'C CLASS old' && houmanCarYear2 > 2006 && houmanCarYear2 < 2014 && wheelsstatus === 'Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && Number(filteredProducts[i].children[j].wheel_width) > 7.4 && Number(filteredProducts[i].children[j].wheel_width) < 9.6 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && ( fProductstest[k].children[m].wheel_width === '9.5' || fProductstest[k].children[m].wheel_width === '9') ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }
    if (Vehiclesearch && Vehiclesearch === 'C CLASS new' && houmanCarYear2 > 2013 && houmanCarYear2 < 2022 && wheelsstatus === 'Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && Number(filteredProducts[i].children[j].wheel_width) > 8.4 && Number(filteredProducts[i].children[j].wheel_width) < 9.6 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && ( fProductstest[k].children[m].wheel_width === '9.5' || fProductstest[k].children[m].wheel_width === '9') ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }

    if (Vehiclesearch && Vehiclesearch === 'C43' && wheelsstatus === 'Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && Number(filteredProducts[i].children[j].wheel_width) > 7.9 && Number(filteredProducts[i].children[j].wheel_width) < 9.6 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children.length < 3 && fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && Number(fProductstest[k].children[0].offsetmm) < 31 && !(fProductstest2.indexOf(fProductstest[k]) >= 0)) {
            fProductstest2.push(fProductstest[k]);
          } else if (fProductstest[k].children.length > 2 && fProductstest[k].children[0].wheel_width !== fProductstest[k].children[2].wheel_width && Number(fProductstest[k].children[0].offsetmm) < 31 && !(fProductstest2.indexOf(fProductstest[k]) >= 0)) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }

    if (Vehiclesearch && Vehiclesearch === 'BMW 3 old' && houmanCarYear2 > 2005 && houmanCarYear2 < 2013 && wheelsstatus === 'Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && Number(filteredProducts[i].children[j].wheel_width) > 7.4 && Number(filteredProducts[i].children[j].wheel_width) < 10.1 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && ( fProductstest[k].children[m].wheel_width === '9' || fProductstest[k].children[m].wheel_width === '9.5' || fProductstest[k].children[m].wheel_width === '10') ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      for (let v = 0; v < fProductstest2.length; v++) {
        for (let w = 0; w < fProductstest2[v].children.length; w++) {
          if ( fProductstest2[v].children[w].wheel_width === '10.5' ) {
            const fpindex1 = fProductstest2.indexOf(fProductstest2[v]);
            fProductstest2.splice(fpindex1, 1);
          }
        }
      }
      for (let v = 0; v < fProductstest2.length; v++) {
        for (let w = 0; w < fProductstest2[v].children.length; w++) {
          if ( fProductstest2[v].children[w].wheel_width === '10.5' ) {
            const fpindex1 = fProductstest2.indexOf(fProductstest2[v]);
            fProductstest2.splice(fpindex1, 1);
          }
        }
      }
      return fProductstest2;
    }
    if (Vehiclesearch && Vehiclesearch === 'BMW x5 x6 old' && houmanCarYear2 > 2006 && houmanCarYear2 < 2019 && wheelsstatus === 'Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && Number(filteredProducts[i].children[j].wheel_width) > 8.4 && Number(filteredProducts[i].children[j].wheel_width) < 11.1 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && ( fProductstest[k].children[m].wheel_width === '10.5' || fProductstest[k].children[m].wheel_width === '11') ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }
    if ( Vehiclesearch && Vehiclesearch === 'BMW x5 x6 new' && houmanCarYear2 > 2018 && houmanCarYear2 < 2023 && wheelsstatus === 'Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && Number(filteredProducts[i].children[j].wheel_width) > 8.4 && Number(filteredProducts[i].children[j].wheel_width) < 11.1 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && ( fProductstest[k].children[m].wheel_width === '10.5' || fProductstest[k].children[m].wheel_width === '11') ) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }
    if ( Vehiclesearch && Vehiclesearch === 'BMW 3-4 old' && houmanCarYear2 > 2012 && houmanCarYear2 < 2019 && wheelsstatus === 'Staggered') {
      for (let i = 0; i < filteredProducts.length; i++) {
        for (let j = 0; j < filteredProducts[i].children.length; j++) {
          if ( sizes.indexOf(filteredProducts[i].children[j].wheel_size) >= 0 && Number(filteredProducts[i].children[j].wheel_width) > 7.4 && Number(filteredProducts[i].children[j].wheel_width) < 10.1 && !(fProductstest.indexOf(filteredProducts[i]) >= 0) ) {
            fProductstest.push(filteredProducts[i]);
          }
        }
      }
      for (let k = 0; k < fProductstest.length; k++) {
        for (let m = 0; m < fProductstest[k].children.length; m++) {
          if ( fProductstest[k].children[0].wheel_width !== fProductstest[k].children[1].wheel_width && ( fProductstest[k].children[m].wheel_width === '9' || fProductstest[k].children[m].wheel_width === '10')) {
            fProductstest2.push(fProductstest[k]);
          }
        }
      }
      return fProductstest2;
    }
    return filteredProducts;
  }

  getSelectedFilterOptions(filter) {
    const nameArray = [];

    if (filter === undefined || filter === null) {
      return [];
    }
    for (let i = 0; i < filter.length; i++) {
      nameArray.push(filter[i].name);
    }
    return nameArray;
  }

  filterSelectedBrands(brandsNames, manufacturer) {
    if (brandsNames.length === 0) {
      return true;
    }
    return brandsNames.indexOf(manufacturer) >= 0;
  }

  filterSelectedWidth(widths, product) {
    if (!widths || widths.length === 0) {
      return true;
    }
    const p_ws = [];
    if (product.wheel_width) {p_ws.push(product.wheel_width);}
    if (product.children) {
      for (const indx in product.children) {
        if (product.children[indx].wheel_width) {p_ws.push(product.children[indx].wheel_width);}
      }
    }
    const intersect = widths.filter(value => p_ws.indexOf(value) !== -1);
    if (intersect.length === 0) {return false;}
    return true;
  }

  filterChrome(product, chromeSelected) {
    const winterColours = ['AD -Matte GLD', 'Anthracite', 'ANTHRACITE GRAY', 'AU -GLD', 'BD -Matte BLK', 'BL -Gloss BLK',
      'BLACK BRONZE', 'Black Gloss', 'Black Matte', 'Black Powder', 'BLD-Gloss Matte BLK', 'BR -BRZ',
      'Bright Silver With Clearcoat', 'BRONZE', 'Bronze', 'BRONZE W/BLACK BOLTS', 'CARBON GRAPHITE', 'CAST IRON BLACK',
      'Charcoal', 'CHARCOAL', 'Copper', 'Copper Paint', 'DESERT SAND', 'Double Black - Matt Black',
      'DOUBLE BLACK - MATTE BLACK W/GLOSS BLACK FACE', 'Double Black - Matte Black W/Gloss Black Face', 'FLAT BLACK',
      'FLAT GUNMETAL', 'Flat Gunmetal', 'FLAT GUNMETAL W/ BLACK  INSERTS', 'Full Satin Black', 'GD -Matte GUN',
      'Gloss Black', 'GLOSS BLACK', 'GLOSS BLACK  (BLACK HEX NUT)', 'Gloss Black(Black Hex Nut)', 'Gloss Bronze',
      'GLOSS GOLD', 'Gloss Gold', 'GLOSS GOLD W/GLOSS BLACK', 'Gloss Graphite', 'GLOSS GRAPHITE',
      'GLOSS GUNMETAL', 'Gloss Gunmetal', 'Gloss Gunmetal W/ Black', 'GLOSS SILVER', 'GLOSS TITANIUM', 'GOLD', 'Gold', 'Graphite', 'GRAPHITE', 'Gray',
      'Grey', 'GUN BLACK', 'GUN METAL', 'GUNBLACK', 'Gunmetal', 'Gunmetal', 'GUNMETAL', 'GunMetal Gloss', 'GunMetal Matte',
      'HIGH GLOSS GUNMETAL', 'High Gloss Silver', 'HYPER BLACK', 'Hyper Black', 'HYPER SILVER', 'Hyper Silver',
      'Hyper Silver Dark', 'Matte Black', 'MATTE BLACK', 'Matte Bronze', 'MATTE BRONZE', 'Matte Gold', 'MATTE GRAPHITE',
      'Matte Graphite', 'MATTE GRAY', 'MATTE GUNMETAL', 'Matte Gunmetal', 'Matte Titanium Silver', 'MATTE TITANIUM SILVER',
      'METALLIC BLACK', 'METALLIC GUNMETAL', 'METHOD BRONZE', 'PEARL GRAY', 'SAND ON BLACK', 'Sand On Black', 'SATIN BLACK',
      'SATIN BLACK W/ CLEAR COAT', 'Satin Bronze', 'SATIN BRONZE', 'SATIN GRAY', 'Pvd # 1', 'Silver W/ Polished Accents',
      'Satin Gunmetal', 'SD -Matte SIL', 'SEMI GLOSS BLACK', 'Semi Gloss Black', 'Silve Gloss', 'Silver', 'SILVER',
      'Silver Gloss', 'SL -Gloss  SIL', 'SL -Gloss SIL', 'STEEL GREY', 'TEXTURED BLACK', 'TEXTURED MATTE BLACK', 'Pvd',
      'Textured Matte Black', 'TEXTURED MATTE GUNMETAL', 'TITANIUM', 'VD -Matte ANT', 'VL -Gloss  ANT', 'VL -Gloss ANT',
      'ZD -Matte BRZ', 'ZDB-Matte BRZ BLK', 'Dark Bronze', 'Dark Gunmetal', 'Matt Anthracite', 'Matt Black', 'Matt Bronze',
      'Matt Gunmetal', 'Matt Silver', 'Metallic Silver', 'Satin Black', 'High Gloss Gunmetal', 'Double Black - Matte Black',
      'Gunblack', 'Desert Sand', 'Matte Grey', 'Full Black', 'Full Matte Black', 'Gloss Silver', 'Hypersilver', 'Black Texture',
      'All Gloss Black', 'Stealth Black', 'All Matte Bronze', 'All Flat Black', 'Flat Bronze', 'Flat Black', 'Bright Silver',
      'Pearl Gray', 'Matte Gray', 'Black/Bronze', 'Cast Iron Black', 'Textured Black', 'Black Magic', 'Satin Dark Gunmetal'];

    const checkWinter = window.localStorage.getItem('winter wheels');

    if (this.props.params.category === 'Winter Packages') {
      return chromeSelected ? false : winterColours.includes(product.wheel_finish);
    }

    if (checkWinter && checkWinter === 'false') {
      return chromeSelected ? false : winterColours.includes(product.wheel_finish);
    }
    return chromeSelected ? product.wheel_finish === 'Chrome' || product.wheel_finish === 'P  -Chrome' : true;
  }

  filtershipping = (product, shipping) => {

    if (!shipping) {return true;}
    if (this.props.params.category === 'wheels') {
      return product.shipping !== '';
    }
    return product.children.filter(
                (child) => {
                  return child.Shipping === 'Local Vancouver Stock';
                }
            ).length > 0;
  }

  filterSelectedPriceRange(product, maxPrice, minPrice) {
    let price = [];
    if (product.price) {price.push(product.price);}
    if (product['back-price']) {price.push(product['back-price']);}
    if (product['front-price']) {price.push(product['front-price']);}
    if (!price.length) {price = getPrices(this.props.params.size.split('-'), product.children);}
    if ((minPrice === 0 || minPrice === undefined) && (maxPrice === 1000000 || maxPrice === undefined)) {
      return true;
    } else if (minPrice === 0 || minPrice === undefined) {
      return parseInt(Math.min(...price)) <= maxPrice;
    } else if (maxPrice === 1000000 || maxPrice === undefined) {
      return parseInt(Math.max(...price)) >= minPrice;
    }

    return parseInt(Math.min(...price)) <= maxPrice && parseInt(Math.max(...price)) >= minPrice;
  }

  filterSelectedPerformanceCategory = (product, performanceCategories) => {
    if (performanceCategories.length > 0) {
      return performanceCategories.indexOf(product.performance_category) >= 0;
    }
    return true;
  }

  filterSpecialOffers = (product, specialOfferSelected) => {
    if (!specialOfferSelected) {return true;}
    if (this.props.params.category === 'Tires') {
      return product.special_price !== '';
    }
    return product.children.filter(
                (child) => {
                  return child.special_price !== null;
                }
            ).length > 0;
  }

  wheelsSort(products) {
    const filters = this.props.filters;
    const { category, search_by, size } = this.props.params;
    const brands = '';
    const brandsNames = this.getSelectedFilterOptions(brands);
    const width = filters.width;
    const widthNames = this.getSelectedFilterOptions(width);
    const chrome = filters.finish ? filters.finish.length > 0 : false;
    const maxPrice = filters.wheelMaxPrice;
    const minPrice = filters.wheelMinPrice;
    const specialOfferSelected = filters.wheelSpecials;
    const shipping = filters.wheelshipping;
    if (brands === undefined && chrome === false && minPrice === undefined && maxPrice === undefined && shipping === undefined) {
      return products.filter((product) => {
        return this.filterChrome(product, chrome);
      });
    }
    return products.filter((product) => {
      return this.filterSelectedBrands(brandsNames, product.wheel_manufacturer);
    })
                .filter((product) => {
                  return this.filterSelectedWidth(widthNames, product);
                })
                .filter((product) => {
                  return this.filterChrome(product, chrome);
                })
                .filter((product) => {
                  return this.filterSelectedPriceRange(product, maxPrice, minPrice);
                })
                .filter((product) => {
                  return this.filterSpecialOffers(product, specialOfferSelected);
                })
                .filter((product) => {
                  return this.filtershipping(product, shipping);
                });
  }

  tiresSort(products) {
    const filters = this.props.filters;
    const brands = filters.tireBrands;
    const brandsNames = this.getSelectedFilterOptions(brands);
    const performanceCategories = filters.performanceCategories;
    const performanceCategoriesNames = this.getSelectedFilterOptions(performanceCategories);
    const speedRatings = filters.speedRatings;
    const speedRatingsNames = this.getSelectedFilterOptions(speedRatings);
    const maxPrice = filters.tireMaxPrice;
    const minPrice = filters.tireMinPrice;
    const specialOfferSelected = filters.tireSpecials;

    function checkSpeedRating(product) {
      if (speedRatingsNames.length > 0) {
        return speedRatingsNames.indexOf(product.speed_rating) >= 0;
      }
      return product;
    }

    if (brands === undefined && performanceCategories === undefined && speedRatings === undefined && minPrice === undefined && maxPrice === undefined) {
      return products;
    }

    return products.filter((product) => {
      return this.filterSelectedPerformanceCategory(product, performanceCategoriesNames);
    })
            .filter(checkSpeedRating)
            .filter((product) => {
              return this.filterSelectedPriceRange(product, maxPrice, minPrice);
            })
            .filter((product) => {
              return this.filterSelectedBrands(brandsNames, product.tire_manufacturer);
            })
            .filter((product) => {
              return this.filterSpecialOffers(product, specialOfferSelected);
            });
  }

  componentWillMount() {
    const { category, search_by, options, size } = this.props.params;
    if (size) {
      if (category === 'Wheels' && search_by === 'Vehicle' || category === 'Winter Packages') {
        this.props.whenClicked(size);
        this.getProductByVehicle(category, options);
      } else {
        if (category === 'Wheels') {
          this.getWheelsBySize(size);
        }
        if (category === 'Tires') {
          this.getTiresBySize(size);
        }
      }
    }
  }

  render() {
    const { category, search_by, size } = this.props.params;
    const { loading, products } = this.state;
    if (localStorage.getItem( 'VancouverInv')) {
      localStorage.removeItem('VancouverInv');
   }

    if (loading) {
      return (
                <div id="productList_loading" className="content-divLength">
                    {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
                        <img src={window.host + '/statics/img/loading.svg'}/> :
                        <img src={window.host + '/statics/img/loading.gif'}/>}
                </div>
      );
    }

    if (products) {
      window.sessionStorage.removeItem('winterPackageSelected');
      window.localStorage.setItem('wheelshipping', 'false');

      return (
                <div id="productList">
                    {category === 'Wheels' && (search_by === 'Vehicle' || search_by === 'Size') || category === 'Winter Packages' ?
                        <ImageSlider productData={this.sizeSort(this.wheelsSort(products))}
                                     groupAttr={this.getGroupAttribute()} searchBy={search_by} size={size}
                                     params={this.props.params}/> :
                        <ImageSlider productData={this.tiresSort(products)} groupAttr={this.getGroupAttribute()}
                                     searchBy={search_by} params={this.props.params}/>
                    }
                </div>
      );
    }

    return (
            <div id="sizesContainer_oemsStandard" className="content-divLength">
                <div className="size-noResultDiv">
                    <div style={{ textAlign: 'center' }}>
                        <h2>No Results</h2>
                    </div>
                </div>
            </div>
          );
  }
}

ProductList.propTypes = {
  filters: React.PropTypes.object.isRequired,
  params: React.PropTypes.object.isRequired,
  whenClicked: React.PropTypes.func
};

ProductList.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default withRouter(ProductList);



// WEBPACK FOOTER //
// ./src/components/ProductList.js